import { useTheme } from '@emotion/react';
import { OpenInNew } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';

const items = [
  {
    id: 1,
    title: '16. Platz',
    description: (
      <>
        ist Deutschland im EU Index für die Digitale Wirtschaft und Gesellschaft{' '}
        <Typography
          component={'span'}
          sx={{
            display: 'inline',
            whiteSpace: 'nowrap',
          }}
        >
          (DESI{' '}
          <IconButton
            href="https://digital-strategy.ec.europa.eu/en/policies/desi-germany"
            target="_blank"
            sx={{
              mt: '-10px',
              color: '#E4E4E4',
              padding: 0,
            }}
          >
            <OpenInNew sx={{ fontSize: '18px' }} />
          </IconButton>
          )
        </Typography>{' '}
        im Bereich Integration digitaler Technologien.
      </>
    ),
  },
  {
    id: 2,
    title: '62%',
    description: (
      <>
        der Unternehmen sehen sich laut Branchenverband Bitkom im Bereich
        Digitalisierung eher als{' '}
        <Typography
          component={'span'}
          sx={{
            display: 'inline',
          }}
        >
          Nachzügler.{' '}
          <IconButton
            href="https://www.bitkom.org/sites/main/files/2024-02/240229Bitkom-ChartsDigitaliserung-der-Wirtschaftfinal.pdf"
            target="_blank"
            sx={{
              mt: '-10px',
              color: '#E4E4E4',
              padding: 0,
            }}
          >
            <OpenInNew sx={{ fontSize: '18px' }} />
          </IconButton>
        </Typography>
      </>
    ),
  },
  {
    id: 3,
    title: '500 Mrd.',
    description: (
      <>
        Euro Potential verschenkte Deutschland laut McKinsey 2016 im Bereich
        Digitalisierung und lag damit weiter unter dem{' '}
        <Typography
          component={'span'}
          sx={{
            display: 'inline',
          }}
        >
          Durchschnitt.{' '}
          <IconButton
            href="https://www.mckinsey.com/capabilities/mckinsey-digital/our-insights/digital-europe-realizing-the-continents-potential/de-DE"
            target="_blank"
            sx={{
              mt: '-10px',
              color: '#E4E4E4',
              padding: 0,
            }}
          >
            <OpenInNew sx={{ fontSize: '18px' }} />
          </IconButton>
        </Typography>
      </>
    ),
  },
];

export default function Why() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        backgroundColor: '#0E3B43',
        py: '120px',
      }}
    >
      <Box
        sx={{
          mb: '88px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '60%',
          maxWidth: '1000px',
          [theme.breakpoints.down('md')]: {
            width: '80%',
          },
        }}
      >
        {items.map((item) => (
          <Box
            key={item.id}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              mb: '32px',
              [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
              },
            }}
          >
            <Typography
              sx={{
                color: 'primary.main',
                fontSize: '48px',
                textAlign: 'right',
                fontWeight: '800',
                width: '40%',
                pr: '60px',
                [theme.breakpoints.down('sm')]: {
                  width: '100%',
                  textAlign: 'left',
                  pr: 0,
                },
              }}
            >
              {item.title}
            </Typography>

            <Typography
              sx={{
                color: '#fff',
                fontSize: '24',
                textAlign: 'left',
                width: '60%',
                pt: '16px',
                [theme.breakpoints.down('sm')]: {
                  width: '100%',
                },
              }}
            >
              {item.description}
            </Typography>
          </Box>
        ))}
      </Box>

      <Typography
        sx={{
          color: '#fff',
          textAlign: 'center',
          fontFamily: 'Karla, sans-serif',
          fontWeight: '800',
          fontSize: '2.8rem',
          [theme.breakpoints.down('md')]: {
            width: '80%',
          },
        }}
      >
        Das möchten wir ändern!
      </Typography>
    </Box>
  );
}
